var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_432_27390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_432_27390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 7.16634H16.666V5.49967H3.33268V7.16634ZM1.66602 5.49967C1.66602 5.04134 1.82921 4.64898 2.1556 4.32259C2.48199 3.9962 2.87435 3.83301 3.33268 3.83301H16.666C17.1243 3.83301 17.5167 3.9962 17.8431 4.32259C18.1695 4.64898 18.3327 5.04134 18.3327 5.49967V10.4997H3.33268V15.4997H6.74935V17.1663H3.33268C2.87435 17.1663 2.48199 17.0031 2.1556 16.6768C1.82921 16.3504 1.66602 15.958 1.66602 15.4997V5.49967ZM12.4577 18.833L8.91602 15.2913L10.0827 14.1247L12.4577 16.458L17.166 11.7497L18.3327 12.958L12.4577 18.833ZM3.33268 5.49967V15.4997V11.7497V14.1038V5.49967Z",
    fill: "#3B0069"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScore);
export default __webpack_public_path__ + "static/media/credit_score.e807d9a6dce5e8eb1ad6fc1edb7d91e8.svg";
export { ForwardRef as ReactComponent };